<template>
  <div class="graphic-design-container">
    <div class="header-section">
      <h1>{{ graphicDesign.title }}</h1>
      <p class="subtitle">{{ graphicDesign.subtitle }}</p>
    </div>
    
    <div class="projects-grid">
      <div class="column">
        <div v-for="project in oddProjects" :key="project.id" class="project-card">
          <div class="project-gallery">
            <a :href="project.image" class="image-popup">
              <img :src="project.image" :alt="project.alt">
            </a>
            <div class="gallery-overlay">
              <div class="zoom-btn" @click="openPopup(project.image)">
                <i class="fas fa-search-plus"></i>
              </div>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Client:</span>
                <span class="value">{{ project.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div v-for="project in evenProjects" :key="project.id" class="project-card">
          <div class="project-gallery">
            <a :href="project.image" class="image-popup">
              <img :src="project.image" :alt="project.alt">
            </a>
            <div class="gallery-overlay">
              <div class="zoom-btn" @click="openPopup(project.image)">
                <i class="fas fa-search-plus"></i>
              </div>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Client:</span>
                <span class="value">{{ project.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HomeButton />
</template>

<script>
import $ from 'jquery'
import 'magnific-popup/dist/jquery.magnific-popup.js'
import 'magnific-popup/dist/magnific-popup.css'
import '@fortawesome/fontawesome-free/css/all.css'
import HomeButton from '@/components/common/HomeButton.vue'

export default {
  name: 'GraphicDesign',
  components: {
    HomeButton
  },
  data() {
    return {
      graphicDesign: {
        title: "Graphic Design",
        subtitle: "Visual Communication & Brand Identity",
        projects: [
          {
            id: 1,
            image: require('@/assets/img/graphic/Cosmetics/01.jpg'),
            alt: "Cosmetics banner 1",
            title: "Cosmetics banner 1",
            description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
            techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
            client: "Cosmetics Brand",
            category: "Banner",
            year: "2022"
          },
          {
            id: 2,
            image: require('@/assets/img/graphic/Cosmetics/02.gif'),
            alt: "Cosmetics banner 2",
            title: "Cosmetics banner 2",
            description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
            techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
            client: "Cosmetics Brand",
            category: "Banner",
            year: "2022"
          },
          {
            id: 3,
            image: require('@/assets/img/graphic/Cosmetics/03.gif'),
            alt: "Cosmetics banner 3",
            title: "Cosmetics banner 3",
            description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
            techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
            client: "Cosmetics Brand",
            category: "Banner",
            year: "2022"
          },
          {
            id: 4,
            image: require('@/assets/img/graphic/Cosmetics/04.gif'),
            alt: "Cosmetics banner 4",
            title: "Cosmetics banner 4",
            description: "An animated banner that effectively showcases the hair growth brush’s features through dynamic and eye-catching motion graphics.",
            techStack: ["Adobe Photoshop", "Adobe Premiere Pro", "Adobe Illustrator"],
            client: "Cosmetics Brand",
            category: "Banner",
            year: "2022"
          },
          {
            id: 5,
            image: require('@/assets/img/graphic/PC/001.gif'),
            alt: "PC banner 1",
            title: "PC banner 1",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator", "Adobe Premiere Pro"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 6,
            image: require('@/assets/img/graphic/PC/005.jpg'),
            alt: "PC banner 5",
            title: "PC banner 5",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 7,
            image: require('@/assets/img/graphic/PC/002.jpg'),
            alt: "PC banner 2",
            title: "PC banner 2",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 8,
            image: require('@/assets/img/graphic/PC/003.jpg'),
            alt: "PC banner 3",
            title: "PC banner 3",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 9,
            image: require('@/assets/img/graphic/PC/004.jpg'),
            alt: "PC banner 4",
            title: "PC banner 4",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 10,
            image: require('@/assets/img/graphic/PC/006.jpg'),
            alt: "PC banner 6",
            title: "PC banner 6",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 11,
            image: require('@/assets/img/graphic/PC/007.jpg'),
            alt: "PC banner 7",
            title: "PC banner 7",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 12,
            image: require('@/assets/img/graphic/PC/008.jpeg'),
            alt: "PC banner 8",
            title: "PC banner 8",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 13,
            image: require('@/assets/img/graphic/PC/009.jpg'),
            alt: "PC banner 9",
            title: "PC banner 9",
            description: "A set of promotional banners designed for Twitter, using brand-consistent colors and dynamic visuals to boost engagement.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "OMEN",
            category: "Banner",
            year: "2023"
          },
          {
            id: 15,
            image: require('@/assets/img/graphic/logo/wang.png'),
            alt: "Wang Logo",
            title: "Wang Logo",
            description: "This logo was created for an artist, drawing inspiration from a meaningful flower that symbolizes personal memories and emotional depth.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Wang's Work",
            category: "Logo design",
            year: "2022"
          },
          {
            id: 14,
            image: require('@/assets/img/graphic/logo/korekara.jpg'),
            alt: "Korekara Logo",
            title: "Korekara Logo",
            description: "Logo and visual identity design for a fitness gym, crafted to reflect a vibrant and motivational atmosphere.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Korekara gym",
            category: "Logo design",
            year: "2021"
          },
          {
            id: 16,
            image: require('@/assets/img/graphic/other/05.jpg'),
            alt: "Korekara facility exterior",
            title: "Korekara facility exterior",
            description: "Logo and visual identity design for a fitness gym, crafted to reflect a vibrant and motivational atmosphere.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Korekara gym",
            category: "Facility exterior design",
            year: "2021"
          },
          {
            id: 17,
            image: require('@/assets/img/graphic/other/04.png'),
            alt: "Comma talk poster",
            title: "Comma talk poster",
            description: "A promotional poster designed to attract new users by integrating a QR code for easy access and broader outreach.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "comma talk",
            category: "Poster",
            year: "2022"
          },
          {
            id: 18,
            image: require('@/assets/img/graphic/food/002.jpg'),
            alt: "Food banner 1",
            title: "Food banner 1",
            description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Jongno",
            category: "Banner",
            year: "2022"
          },
          {
            id: 19,
            image: require('@/assets/img/graphic/food/003.png'),
            alt: "Food banner 2",
            title: "Food banner 2",
            description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Jongno",
            category: "Banner",
            year: "2022"
          },
          {
            id: 20,
            image: require('@/assets/img/graphic/food/004.png'),
            alt: "Food banner 3",
            title: "Food banner 3",
            description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Jongno",
            category: "Banner",
            year: "2022"
          },
          {
            id: 21,
            image: require('@/assets/img/graphic/food/005.png'),
            alt: "Food banner 4",
            title: "Food banner 4",
            description: "A promotional banner designed for the Jongno EC-commerce website to highlight featured products and convey detailed product information.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Jongno",
            category: "Branding",
            year: "2022"
          },
          {
            id: 22,
            image: require('@/assets/img/graphic/other/01.jpg'),
            alt: "Franchise flyer",
            title: "Franchise flyer",
            description: "A mailbox-distributed flyer designed to attract potential franchise partners with a clear and appealing message.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Wellbe Labo",
            category: "Banner",
            year: "2020"
          },
          {
            id: 23,
            image: require('@/assets/img/graphic/other/03.jpg'),
            alt: "Rental conference room",
            title: "Rental conference room",
            description: "A targeted banner ad created for digital platforms, designed with A/B testing in mind to optimize conversion for rental conference room services.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Rental conference room",
            category: "Banner",
            year: "2020"
          },
          {
            id: 24,
            image: require('@/assets/img/graphic/other/02.jpg'),
            alt: "Rental conference room",
            title: "Rental conference room",
            description: "A targeted banner ad created for digital platforms, designed with A/B testing in mind to optimize conversion for rental conference room services.",
            techStack: ["Adobe Photoshop",  "Adobe Illustrator"],
            client: "Rental conference room",
            category: "Banner",
            year: "2020"
          }
        ]
      }
    }
  },
  computed: {
    sortedProjects() {
      return [...this.graphicDesign.projects].sort((a, b) => a.id - b.id);
    },
    oddProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 1);
    },
    evenProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 0);
    }
  },
  mounted() {
    this.$nextTick(() => {
      $('.image-popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true
        },
        zoom: {
          enabled: true,
          duration: 300
        },
        callbacks: {
          open: function() {
            history.pushState({ popup: true }, '');
          },
          close: function() {
            if (history.state && history.state.popup) {
              history.back();
            }
          }
        }
      });

      window.addEventListener('popstate', this.handlePopState);
    });
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    openPopup(imageUrl) {
      const $link = $('.image-popup').first();
      $link.attr('href', imageUrl);
      $link.trigger('click');
    },
    handlePopState() {
      if ($.magnificPopup.instance.isOpen) {
        $.magnificPopup.close();
      }
    }
  }
}
</script>

<style scoped>
.graphic-design-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2rem;
}

.header-section h1 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
}

.projects-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 992px) {
  .header-section h1 {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    padding: 0;
  }
  
  .graphic-design-container {
    padding: 1rem 0.5rem;
  }
  
  .header-section {
    margin-bottom: 1.5rem;
  }
  
  .header-section h1 {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .header-section h1 {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
  
  .project-info h3 {
    font-size: 1.2rem;
  }
  
  .project-info p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .tech-stack span {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  
  .label {
    font-size: 0.8rem;
  }
  
  .value {
    font-size: 0.9rem;
  }
}

.project-card {
  break-inside: avoid;
  margin-bottom: 1.5rem;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 100%;
}

.project-card:hover {
  transform: translateY(-5px);
}

.project-gallery {
  position: relative;
  overflow: hidden;
}

.project-gallery img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-gallery:hover .gallery-overlay {
  opacity: 1;
}

.zoom-btn {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.zoom-btn:hover {
  background: white;
  transform: scale(1.1);
}

.zoom-btn i {
  color: #333;
  font-size: 1.2rem;
}

.project-info {
  padding: 1.5rem;
}

.project-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
}

.project-info p {
  color: #666;
  margin-bottom: 1rem;
}

.tech-stack {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.tech-stack span {
  background: #f0f0f0;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  color: #555;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.9rem;
  color: #666;
}

.value {
  font-weight: 500;
  color: #333;
}

.image-popup {
  display: block;
  cursor: pointer;
}

/* 触摸设备优化 */
@media (hover: none) {
  .gallery-overlay {
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
  }
  
  .project-card:active {
    transform: translateY(-5px);
  }
}
</style> 